import { createAction, props } from '@ngrx/store';

import { UmResearcher } from 'src/app/models/um-researcher';
import { StudyType } from 'src/app/models/study-type';
import { Role } from 'src/app/models/role';

export const getUmResearchers = createAction('[User Management Researchers] Get Researchers');

export const getUmResearchersSuccess = createAction(
  '[User Management Researchers] Get Researchers Success',
  props<{ researchers: UmResearcher[] }>()
);

export const getUmResearchersError = createAction('[User Management Researchers] Get Researchers Error');

export const selectUmResearcher = createAction(
  '[User Management Researchers] Set Selected Researcher',
  props<{ researcherId: number }>()
);

export const selectUmResearcherSuccess = createAction(
  '[User Management Researchers] Set Selected Researcher Success',
  props<{ selectedUmResearcher: UmResearcher }>()
);

export const selectUmResearcherError = createAction('[User Management Researchers] Set Selected Researcher Error');

export const activateUmResearcher = createAction(
  '[User Management Researchers] Activate Researcher',
  props<{ researcher: UmResearcher }>()
);

export const activateUmResearcherSuccess = createAction(
  '[User Management Researchers] Activate Researcher Success',
  props<{ activatedResearcher: UmResearcher }>()
);

export const activateUmResearcherError = createAction(
  '[User Management Researchers] Activate Researcher Error',
  props<{ error: JSON }>()
);

export const blockUmResearcher = createAction(
  '[User Management Researchers] Block Researcher',
  props<{ researcher: UmResearcher }>()
);

export const blockUmResearcherSuccess = createAction(
  '[User Management Researchers] Block Researcher Success',
  props<{ blockedResearcher: UmResearcher }>()
);

export const blockUmResearcherError = createAction(
  '[User Management Researchers] Block Researcher Error',
  props<{ error: JSON }>()
);

export const changeUmResearcherRole = createAction(
  '[User Management Researchers] Change Researcher Role',
  props<{ researcher: UmResearcher; role: Role }>()
);

export const changeUmResearcherRoleSuccess = createAction(
  '[User Management Researchers] Change Researcher Role Success',
  props<{ upgradedResearcher: UmResearcher }>()
);

export const changeUmResearcherRoleError = createAction(
  '[User Management Researchers] Change Researcher Role Error',
  props<{ error: JSON }>()
);

export const changeUmResearcherStudyType = createAction(
  '[User Management Researchers] Change Researcher Study Type',
  props<{
    researcher: UmResearcher;
    checked: boolean;
    selectedStudyType: StudyType;
  }>()
);

export const changeUmResearcherStudyTypeSuccess = createAction(
  '[User Management Researchers] Change Researcher Study Type Success',
  props<{
    changedStudyTypeResearcher: UmResearcher;
    checked: boolean;
    selectedStudyType: StudyType;
  }>()
);

export const changeUmResearcherStudyTypeError = createAction(
  '[User Management Researchers] Change Researcher Study Type Error',
  props<{ error: JSON }>()
);

export const changeStudyTypeAccess = createAction(
  '[User Management Studies] Change Researcher Study Type Access',
  props<{
    researcher: UmResearcher;
    checked: boolean;
    selectedStudyType: StudyType;
  }>()
);

export const changeStudyTypeAccessSuccess = createAction(
  '[User Management Researchers] Change Researcher Study Type Access Success',
  props<{ changedStudyTypeAccessResearcher: UmResearcher; checked: boolean }>()
);

export const changeStudyTypeAccessError = createAction(
  '[User Management Researchers] Change Researcher Study Type Access Error',
  props<{ error: JSON }>()
);

export const disableUmResearcherTFA = createAction(
  '[User Management Researchers] Disable Researcher TFA',
  props<{ researcher: UmResearcher }>()
);

export const disableUmResearcherTFASuccess = createAction(
  '[User Management Researchers] Disable Researcher TFA Success',
  props<{ disabledResearcherTFA: UmResearcher }>()
);

export const disableUmResearcherTFAError = createAction(
  '[User Management Researchers] Disable Researcher TFA Error',
  props<{ error: JSON }>()
);

export const noopAction = createAction('[User Management Researchers] No Operations Action');
